export const _en = {
    addButton: {
        label: "Add a new profile"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a new profile",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    },
    description: {
        label: "Description"
    },
    name: {
        label: "Name"
    },
    refDivisionId: {
        label: "Division"
    }
};


export const _fr = {
    addButton: {
        label: "Profil"
    },
    toggleDeleted: {
        label: "Afficher les profils archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'un profil",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    description: {
        label: "Description"
    },
    name: {
        label: "Nom"
    },
    refDivisionId: {
        label: "Service"
    }
};